<template>
    <div>
        <el-table border v-loading="loading" :data="blackRangeList" max-height="500px" style="width: 100%">
            <el-table-column show-overflow-tooltip prop="blackReason_" min-width="180" label="拉黑原因"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierCode" label="供应商编码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商名称" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="propertyNature_" label="主体性质" width="100"></el-table-column>
            <el-table-column
                show-overflow-tooltip
                prop="societyCreditCode"
                label="社会信用代码"
                width="180"></el-table-column>
            <el-table-column v-if="requestParams.property === '1'" show-overflow-tooltip prop="corporateName" label="法人名称" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="idCard" label="身份证" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="personName" label="名称" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="driverCode" label="司机编码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="warehouseWorkerNo" label="仓库人员编码" width="180"></el-table-column>
        </el-table>
        <el-pagination
            style="text-align: right;margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import { supplierBlackReason } from '../../../../api/register/aublacklist.js'
import { debounce } from 'lodash'
let debounceFn = null
export default {
    props: {
        requestParams: {
            type: Object,
            default(){
                return {}
            }
        },
    },
    data(){
        return {
            loading: false,
            blackRangeList: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            dict: {},
        }
    },
    watch: {
        'requestParams.property'(){
            this.getData()
        },
        'requestParams.idCard'(){
            this.getData()
        },
        'requestParams.societyCreditCode'(){
            this.getData()
        },
        'requestParams.auditMipId'(){
            this.getData()
        },
    },
    methods: {
        getData(){
            if((this.requestParams.property === '1' && this.requestParams.societyCreditCode) || (this.requestParams.property === '2' && this.requestParams.idCard)){
                debounceFn && debounceFn.cancel()
                debounceFn = debounce(() => {
                    dictWithUrl('SRM_BLACK_SCOPE_REASON_TYPE,SYS_SUPPLIERS_PROPERTY').then(res => {
                        this.dict = res.data;
                        this.supplierBlackReason()
                    });
                }, 350)
                debounceFn()
            }else {
                this.reset()
            }
        },
        reset(){
            this.blackRangeList = []
            this.total = 0
            this.pageNo = 1
        },
        handleSizeChange(v){
            this.pageSize = v
            this.pageNo = 1
            this.supplierBlackReason()
        },
        handleCurrentChange(v){
            this.pageNo = v
            this.supplierBlackReason()
        },
        supplierBlackReason(){
            if((this.requestParams.property === '1' && this.requestParams.societyCreditCode) || (this.requestParams.property === '2' && this.requestParams.idCard)){
                this.loading = true
                supplierBlackReason({...this.requestParams, pageNo: this.pageNo, pageSize: this.pageSize}).then(res => {
                    if (res && +res.code === 0) {
                        this.blackRangeList = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                blackReason_: this.dict['SRM_BLACK_SCOPE_REASON_TYPE'][v.blackReason],
                                propertyNature_: this.dict['SYS_SUPPLIERS_PROPERTY'][v.propertyNature],
                            }
                        })
                        this.total = res.data.totalCount || 0
                    }
                }).finally(() => {
                    this.loading = false
                })
            }else {
                this.reset()
            }
        },
    },
    created() {
        dictWithUrl('SRM_BLACK_SCOPE_REASON_TYPE,SYS_SUPPLIERS_PROPERTY').then(res => {
            this.dict = res.data;
        });
    },
}
</script>
